import {
  GetDocumentTemplateVersionExtendsOptions,
  IDocumentTemplateVersion,
} from '@commenda/types/src/document-generation';
import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';

interface GetDocumentTemplateVersionResponse {
  data: IDocumentTemplateVersion;
}

export const getDocumentTemplateVersion = async (
  documentTemplateVersionId: string,
  queryParams?: { extends?: GetDocumentTemplateVersionExtendsOptions[] }
): Promise<{
  success: boolean;
  data: IDocumentTemplateVersion | null;
}> => {
  try {
    const query = new URLSearchParams();
    if (queryParams?.extends) {
      queryParams.extends.forEach(
        (ext: GetDocumentTemplateVersionExtendsOptions) =>
          query.append('extends', ext)
      );
    }

    const queryString = query.toString();
    const res = await fetcher(
      `${BASE_URL}/version/${documentTemplateVersionId}${queryString ? `?${queryString}` : ''}`,
      {
        method: 'GET',
      }
    );
    if (!res.ok) {
      return {
        success: false,
        data: null,
      };
    }
    const responseData =
      (await res.json()) as GetDocumentTemplateVersionResponse;
    return {
      success: true,
      data: responseData.data,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
    };
  }
};
